<template>
    <div class="tc-question">
        <title-section
            :title="title"
            :text="description"
        >
        </title-section>

        <ButtonAnswers :answers="responses" @input="updateNext(...$event)" :aria-described-by="title + '-subheading'"/>
    </div>
</template>

<script>
    import TitleSection from '../TitleSection.vue';
    import ButtonAnswers from '../buttons/ButtonAnswers.vue';
    import * as track from '@/utilities/tracking';

    export default {
        name: 'BigButtonQuestion',
        components: {
            TitleSection,
            ButtonAnswers
        },
        created: function() {
            this.$store.commit('update', { name: 'previous', value: this.previous });
        },
        mounted() {
            track.step(this.$store.state.step);
        },
        props: {
            title: String,
            description: String,
            responses: Object,
            value: [String, Boolean],
            name: String,
            next: [String, Number],
            previous: [String,Number]
        },

        methods: {
            updateNext: function(next, previous, id) {
                this.$store.commit('update', { name: this.name, value: id });

                if (next == "results") {
                    this.$router.push(next);
                } else {
                    this.$store.commit('update', { name: 'previous', value: previous });
                    this.$store.commit('update', { name: 'step', value: next });
                }
            }
        }
  }
</script>
